export const DeleteConfirm =
  "Você tem certeza de que deseja excluir esse item?";

export const SavedMessage = "Salvo com sucesso";
export const WrongRole =
  "Você não tem permissão para prosseguir, entre em contato com o supervisor";

export const Message = {
  DeleteConfirm: "Você tem certeza de que deseja excluir esse item?",
  Confirm: "Você tem certeza de que deseja continuar?",
  DeleteSuccess: "Removido com sucesso",
  Saved: "Salvo com sucesso",
  Refused: "Recusado com sucesso",
  PendingData: "Preencha os dados para poder salvar",
  PendingReview: "Preencha os dados para acessar seu documento",
  ServiceDataPending: "Não é possível aprovar um orçamento sem serviços",
  CanClose: "Você pode fechar essa janela",
  NotLogged: "Você precisa fazer login para continuar",
  PasswordNotMatch: "As senhas são diferentes",
};
